export const FETCH_SETTINGS = 'settings';
export const UPDATE_ACTIVE_SORT_FIELD_SETTINGS = 'updateActiveSortFieldSettings';
export const UPDATE_SEARCH_SETTINGS = 'updateSearchSettings';
export const CLEAR_SEARCH_SETTINGS = 'clearSearchSettings';
export const DELETE_SETTING = 'deleteSetting';
